import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import Swal from "sweetalert2";

class Comercializadores extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      establecimientos: [],
      estados: ["Inactivo", "Activo", "En espera", "Rechazado"],
      nivelUsuario: localStorage.nivel_actual,
    };

    this.rechazar = this.rechazar.bind(this);
    this.aceptar = this.aceptar.bind(this);
    this.miAsociacionComercial = this.miAsociacionComercial.bind(this);
    this.swt = this.swt.bind(this);
    this.miAsociacionComercial();
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }
  }

  miAsociacionComercial() {
    Api.fetch("app/getMiAsociacionComercial", {}, "POST").then((data) => {
      this.setState({
        establecimientos: data,
      });
      Api.loading(0);
    });
  }

  rechazar(e) {
    let id = e.target.dataset.id;
    let msg =
      "¿Seguro que desea rechazar este comercializador?" +
      `<textarea rows=5 class="form-control" id="razon" placeholder="Ingrese la razón de esta acción"></textarea>`;
    let obs = "";

    Swal.fire({
      title: "Atención",
      icon: "warning",
      html: msg,
      confirmButtonText: "Aceptar",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      preConfirm: (r) => {
        obs = document.querySelector("#razon").value;
        if (obs === "") {
          Swal.showValidationMessage("Es obligatorio ingresar una observación");
        }
      },
    }).then((result) => {
      //Api.loading(1);
      if (result.isConfirmed) {
        Api.fetch(
          "app/rechazaAssocPlanta",
          { id: id, observacion: obs },
          "POST"
        ).then((data) => {
          this.miAsociacionComercial();
        });
      }
    });
  }

  aceptar(e) {
    let id = e.target.dataset.id;
    Swal.fire({
      title: "Atención",
      icon: "warning",
      text: "¿Seguro que desea aceptar a comercializador?.",
      confirmButtonText: "Aceptar",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      //Api.loading(1);
      if (result.isConfirmed) {
        Api.fetch("app/aceptaAssocPlanta", { id: id }, "POST").then((data) => {
          this.miAsociacionComercial();
        });
      } else {
      }
    });
  }

  swt(e) {
    let id = e.target.dataset.id;
    let swt = e.target.dataset.activo;
    let msg = "";
    let obs = "";
console.log(e.target.dataset.activo);
    if (swt === "1") {
      msg =
        "Esta acción desactivará esta asociación" +
        `<textarea rows=5 class="form-control" id="razon" placeholder="Ingrese la razón de esta acción"></textarea>`;
      swt = 0;
    } else {
      swt = 1;
      msg =
        "Esta acción activará esta asociación" +
        `<textarea rows=5 class="form-control" id="razon" placeholder="Ingrese la razón de esta acción"></textarea>`;
    }

    Swal.fire({
      title: "Atención",
      icon: "warning",
      html: msg,
      confirmButtonText: "Aceptar",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      preConfirm: (r) => {
        obs = document.querySelector("#razon").value;
        if (obs === "" && swt === 0) {
          Swal.showValidationMessage("Es obligatorio ingresar una observación");
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(1);
        Api.fetch(
          "app/switchPlantaActiva",
          { id: id, switch: swt, observacion: obs },
          "POST"
        ).then((data) => {
          this.miAsociacionComercial();
        });
      }
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">Comercializadores</li>
        </ol>
        <h1 className="page-header">Comercializadores</h1>
        <div className="row">
          <Panel className="col-sm-12">
            <PanelBody>
              <fieldset className="col-sm-12">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th>COMERCIALIZADOR</th>
                      <th>ESTABLECIMIENTO</th>
                      <th>GUID</th>
                      <th>OBSERVACIÓN</th>
                      <th>ESTADO</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.establecimientos.length > 0 ? (
                      this.state.establecimientos.map((est, index) => (
                        <tr key={index} id={"t" + index}>
                          <td>
                            {est.name +
                              " " +
                              est.apellido_paterno +
                              " " +
                              est.apellido_materno}
                          </td>
                          <td>{est.razon_social}</td>
                          <td>{est.guid}</td>
                          <td>
                            {est.observacion === null ? "-" : est.observacion}
                          </td>
                          <td>{this.state.estados[est.activo]}</td>
                          <td>
                            {est.activo === "2" ? ( //En espera
                              <div class="btn-group" role="group">
                                <button
                                  onClick={this.aceptar}
                                  className="btn btn-success"
                                  data-id={est.id}
                                >
                                  <i
                                    data-id={est.id}
                                    className="fas fa-check"
                                  ></i>
                                </button>
                                <button
                                  onClick={this.rechazar}
                                  className="btn btn-danger"
                                  data-id={est.id}
                                >
                                  <i
                                    data-id={est.id}
                                    className="fas fa-times"
                                  ></i>
                                </button>
                              </div>
                            ) : null}

                            {est.activo === "1" ? (
                              <button
                                onClick={this.swt}
                                className="btn btn-primary"
                                data-id={est.id}
                                data-activo={est.activo}
                              >
                                <i
                                  data-id={est.id}
                                  data-activo={est.activo}
                                  className="fas fa-unlock"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                            {est.activo === "0" ? (
                              <button
                                onClick={this.swt}
                                className="btn btn-secondary"
                                data-id={est.id}
                                data-activo={est.activo}
                              >
                                <i
                                  data-id={est.id}
                                  data-activo={est.activo}
                                  className="fas fa-lock"
                                ></i>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr key="1">
                        <td className="text-center" colSpan="9">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <hr />
                <div className="text-right">
                  Todos los campos marcados con{" "}
                  <span style={{ color: "red" }}>*</span> son requeridos.
                </div>
              </fieldset>
            </PanelBody>
          </Panel>
        </div>
      </div>
    );
  }
}

export default Comercializadores;
